import { APP_LANGUAGE, ENTERPRISE, ENTERPRISE_DATA, USER_ACCOUNT_ID, USER_ID, USER_NAME, USER_PERMISSION, USER_ROLE, USER_TOKEN, USER_USERNAME } from "./const";

/**
 * Get current cached office ID
 * 
 * @returns Current office ID
 */
export function getOffice() {
    return localStorage.getItem(ENTERPRISE);
}

/**
 * Check the user is logged in or not
 * 
 * @returns login status true|false
 */
export function isLogin() {
    return getToken() !== null;
}

/**
 * Get current login token for authentication
 * 
 * @returns current login token
 */
export function getToken() {
    return localStorage.getItem(USER_TOKEN);
}

export function getRole() {
    return localStorage.getItem(USER_ROLE);
}

export function getUserID() {
    return localStorage.getItem(USER_ID);
}

export function getUserName() {
    return localStorage.getItem(USER_USERNAME);
}

export function getName() {
    return localStorage.getItem(USER_NAME);
}

export function getAccountID() {
    return localStorage.getItem(USER_ACCOUNT_ID);
}

export function setOffice(office) {
    localStorage.setItem(ENTERPRISE, office);
}

export function setLogin(token, role, user, account, username, name) {
    localStorage.setItem(USER_TOKEN, token);
    localStorage.setItem(USER_ROLE, role);
    localStorage.setItem(USER_ID, user);
    localStorage.setItem(USER_ACCOUNT_ID, account);
    localStorage.setItem(USER_USERNAME, username);
    localStorage.setItem(USER_NAME, name);
}

export function removeLogin() {
    localStorage.removeItem(USER_TOKEN);
    localStorage.removeItem(ENTERPRISE_DATA);
    localStorage.removeItem(USER_PERMISSION);
    localStorage.removeItem(USER_ROLE);
    localStorage.removeItem(USER_ID);
    localStorage.removeItem(USER_ACCOUNT_ID);
    localStorage.removeItem(USER_USERNAME);
    localStorage.removeItem(USER_NAME);
}

export function getLanguage() {
    return localStorage.getItem(APP_LANGUAGE) || "en";
}

export function setLanguage(lang) {
    localStorage.setItem(APP_LANGUAGE, lang);
}